module.exports = __webpack_public_path__ + "img/383-65bc40.png";